module.exports = __webpack_public_path__ + "media/cellular.fec05ad7.wav";